import React from 'react';
import { connect } from 'react-redux';
import { StatisticsByReferralSegments } from './StatisticsByReferralSegments';

const StatisticsByReferralSegmentsComponent = connect(
    function mapStateToProps(state) {
        return {
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByReferralSegments);

export default StatisticsByReferralSegmentsComponent;
